{
  "GATStudio": {
    "API_URL": "https://api.gamelearn.io/",
    "ASSETS_URL": "https://min.objects.gamelearn.io/statics/gamelearn/resources",
    "CLIENT": "5981fca94d82290bcbe957fe",
    "RESOURCE_URL": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "SERVICE_ID": "d52c4f2e-c466-4304-aa71-1cd3c555716d",
    "SERVICE_URL": "https://services.gamelearn.io",
    "TRANSLATIONS_URL": "https://min.objects.gamelearn.io/gl-i18n/pro/studio/"
  },
  "accounts": {
    "apiUrl": "https://api.gamelearn.io",
    "contentful": {
      "accessToken": "ee5c130c30267ab908f08f5244773edc1fadfa3a02d456a8e68f6e5b4cbd53a6",
      "active": true,
      "contentTypeIds": {
        "warningMessage": "mensajeDeWarning"
      },
      "space": "fbgigh3s9vtp",
      "warningMessageActive": true
    },
    "cookieDomain": ".gamelearn.io",
    "dictionaryUrl": "https://min.objects.gamelearn.io/gl-style-dictionary",
    "domain": "gamelearn.io",
    "journal": {
      "agent": "https://journal-agent.gamelearn.io/journal.js",
      "url": "https://api.gamelearn.io/journal"
    },
    "lmsUrl": "https://admin.gamelearn.io",
    "resourcesUrl": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "sentry": {
      "dsn": "https://57c687f097f64debb34663f73023f885@o436063.ingest.sentry.io/5623369",
      "show": true
    },
    "serviceId": "a0647baf-3ed5-484a-9240-4944dc7dbe5f",
    "serviceUrl": "https://services.gamelearn.io?sid=a0647baf-3ed5-484a-9240-4944dc7dbe5f",
    "supportUrl": "https://support.game-learn.com",
    "surveyUrl": "https://surveyprepost.gamelearn.io/",
    "translationsUrl": "https://min.objects.gamelearn.io/gl-i18n/pro/accounts/"
  },
  "ai-frontend": {},
  "arcade": {
    "GlRecommendy": {
      "active": true,
      "apiUrl": "https://api.gamelearn.io",
      "authorization": true,
      "campusUrl": "https://campus.gamelearn.io",
      "disableOnEmbeddedMode": true,
      "resourcesUrl": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
      "script": "https://script.gamelearn.io/recommendy/recommendy.js"
    },
    "VITE_API_URL": "https://api.gamelearn.io",
    "VITE_CAMPUS_URL": "https://campus.gamelearn.io",
    "VITE_CLIENT": "58dccfba26561500117caf53",
    "VITE_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "VITE_JOURNAL_AGENT": "https://script.gamelearn.io/journal/journal.js",
    "VITE_JOURNAL_URL": "https://api.gamelearn.io/journal",
    "VITE_MINIO_URL": "https://min.objects.gamelearn.io/",
    "VITE_RECOMENDY_SCRIPT": "https://script.gamelearn.io/recommendy/recommendy.js",
    "VITE_RESOURCES_HOST": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "VITE_SERVICES_URL": "https://services.gamelearn.io",
    "VITE_SERVICE_ID": "a03431b1-c799-4525-9400-bae0062e7afa",
    "VITE_STATICS_URL": "https://min.objects.gamelearn.io/statics",
    "VITE_STREAMING_HOST": "https://streaming.st2.gamelearn.io/clients/",
    "VITE_TRANSLATION_HOST": "https://min.objects.gamelearn.io/gl-i18n/pro/gat-games/",
    "VITE_TTS_URL": "https://tts.objects.gamelearn.io/api",
    "VITE_VOICES_URL": "https://tts.objects.gamelearn.io/api/file",
    "VITE_STORYLINES_DB": "https://storylinesdb.st2.gamelearn.io/fetch?url=",
    "VITE_STORYLINES_FROM_MINIO": "false"
  },
  "arcade-animixer": {
    "VITE_API_URL": "https://api.gamelearn.io",
    "VITE_CAMPUS_URL": "https://campus.gamelearn.io",
    "VITE_CLIENT": "58dccfba26561500117caf53",
    "VITE_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "VITE_JOURNAL_AGENT": "https://journal-agent.gamelearn.io/journal.js",
    "VITE_JOURNAL_URL": "https://api.gamelearn.io/journal",
    "VITE_MINIO_URL": "https://min.objects.gamelearn.io/",
    "VITE_RESOURCES_HOST": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "VITE_SERVICES_URL": "https://services.gamelearn.io",
    "VITE_SERVICE_ID": "5154560c-e86c-45a2-8ff5-bc38f11535d3",
    "VITE_STATICS_URL": "https://min.objects.gamelearn.io/statics",
    "VITE_TRANSLATION_HOST": "https://min.objects.gamelearn.io/gl-i18n/gat-games/",
    "production": true
  },
  "arcade-studio": {
    "ACCOUNTS_URL": "https://accounts.gamelearn.io/",
    "API_URL": "https://api.gamelearn.io",
    "ASSETS_URL": "https://min.objects.gamelearn.io/statics/",
    "CLIENT": "58dccfba26561500117caf53",
    "DEFAULT_SCENE_ID": "5f9be8835ca1de00112844d6",
    "DOMAIN": "domain=.gamelearn.io",
    "KEPLER_ASSETS_URL": "https://min.objects.gamelearn.io/kepler/assets",
    "REACT_APP_API_URL": "https://api.gamelearn.io",
    "REACT_APP_CAMPUS_URL": "http://campus.gamelearn.io",
    "REACT_APP_CLIENT": "58dccfba26561500117caf53",
    "REACT_APP_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "REACT_APP_RESOURCES_HOST": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "REACT_APP_SERVICES_URL": "http://services.gamelearn.io",
    "REACT_APP_STATICS_URL": "https://min.objects.gamelearn.io/statics",
    "REACT_APP_TRANSLATION_HOST": "https://min.objects.gamelearn.io/gl-i18n/gat-games/",
    "SERVICES_URL": "https://services.gamelearn.io",
    "SERVICE_ID": "94cca5a3-0c00-4cff-8667-18f0da843c5f",
    "SERVICE_ID_EDITOR": "5154560c-e86c-45a2-8ff5-bc38f11535d3",
    "cookieDomain": "domain=.gamelearn.io",
    "production": true
  },
  "authoring-tool": {
    "ACCOUNTS_URL": "https://accounts.gamelearn.io/",
    "API_URL": "https://api.gamelearn.io",
    "ASSETS_URL": "https://min.objects.gamelearn.io/statics/",
    "CLARITY": {
      "enabled": true
    },
    "CLIENT": "5981fca94d82290bcbe957fe",
    "DEFAULT_SCENE_ID": "5f9be8835ca1de00112844d6",
    "DOMAIN": "gamelearn.io",
    "EDITOR_MULTIPLAYER_URL": "wss://editor-multiplayer.gamelearn.io:443",
    "ENGINE_BACKEND": "https://api.gamelearn.io/arcade",
    "ENGINE_LOGIN": "https://arcade.gamelearn.io/",
    "JOURNAL": {
      "agent": "https://journal-agent.gamelearn.io/journal.js",
      "url": "https://api.gamelearn.io/journal"
    },
    "LMS_URL": "https://admin.gamelearn.io",
    "PLAYGROUND_URL": "https://arcade.gamelearn.io/playground",
    "POLYGLOT_WEBSOCKET_URL": "wss://polyglot.gamelearn.io:443",
    "PREVIEW_URL": "https://arcade.gamelearn.io/preview",
    "RESOURCES_HOST": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "S3_BUCKET_PARAMS": {
      "Bucket": "https://min.objects.gamelearn.io/statics/"
    },
    "SCENE_COMPOSER_URL": "https://scene-composer.gamelearn.io",
    "SERVICES_URL": "https://services.gamelearn.io",
    "SERVICE_ID": "5154560c-e86c-45a2-8ff5-bc38f11535d3",
    "STREAMING_HOST": "https://streaming.st2.gamelearn.io/clients/",
    "STUDENTS_URL": "https://campus.gamelearn.io",
    "SUPPORT_URL": "https://support.game-learn.com",
    "TEXT_CLICK_CLIENT_IDS": "5981fca94d82290bcbe957fe,5a3bdd7081d725000fd6b858",
    "TRANSLATIONS_URL": "https://min.objects.gamelearn.io/gl-i18n/pro/authoring/",
    "TTS_URL": "https://tts.objects.gamelearn.io/api",
    "VOICES_URL": "https://tts.objects.gamelearn.io/api/file/",
    "cookieDomain": ".gamelearn.io",
    "microfrontends": {
      "GlCookies": {
        "active": true,
        "components": [
          "modal"
        ],
        "script": "https://script.gamelearn.io/glcookies/glcookies.js"
      }
    },
    "production": true
  },
  "campus": {
    "GAMELEARN_CLIENT_ID": "5981fca94d82290bcbe957fe",
    "apiUrl": "https://api.gamelearn.io",
    "campusUrl": "https://campus.gamelearn.io/",
    "contentful": {
      "accessToken": "ee5c130c30267ab908f08f5244773edc1fadfa3a02d456a8e68f6e5b4cbd53a6",
      "active": true,
      "contentTypeIds": {
        "warningMessage": "mensajeDeWarning"
      },
      "space": "fbgigh3s9vtp",
      "warningMessageActive": true
    },
    "cookieDomain": ".gamelearn.io",
    "dictionaryUrl": "https://min.objects.gamelearn.io/gl-style-dictionary",
    "diplomasUrl": "https://share.gamelearn.io/diplomas/",
    "domain": "gamelearn.io",
    "editorUrl": "https://editor.gamelearn.io/",
    "ft": {
      "enableLogin": true
    },
    "gtm": {
      "enabled": true
    },
    "journal": {
      "agent": "https://script.gamelearn.io/journal/journal.js",
      "url": "https://api.gamelearn.io/journal"
    },
    "linkedinConfig": {
      "client_id": "78hvuxta6257fz",
      "redirect_uri": "https://api.gamelearn.io/core/users/linkedin",
      "state": "s6Yxqm6wP4cRLcF7"
    },
    "lmsUrl": "https://admin.gamelearn.io/",
    "microfrontends": {
      "GlCookies": {
        "active": true,
        "components": [
          "modal"
        ],
        "script": "https://script.gamelearn.io/glcookies/glcookies.js"
      },
      "GlRecommendy": {
        "active": true,
        "apiUrl": "https://api.gamelearn.io",
        "authorization": true,
        "campusUrl": "https://campus.gamelearn.io",
        "disableOnEmbeddedMode": true,
        "resourcesUrl": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
        "script": "https://script.gamelearn.io/recommendy/recommendy.js"
      }
    },
    "resourcesUrl": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "sentry": {
      "dsn": "https://addf7db100074dc1aa2ad2f708380dad@o436063.ingest.sentry.io/5624290",
      "show": true
    },
    "serviceId": "a5c180aa-3ca0-4869-b79e-c6612c7490b8",
    "serviceIdPwa": "eff42bd7-b44d-4163-a51c-698bc0a804ef",
    "servicesUrl": "https://services.gamelearn.io",
    "streamingUrl": "https://streaming.st2.gamelearn.io/clients/",
    "supportUrl": "https://support.game-learn.com",
    "translationsUrl": "https://min.objects.gamelearn.io/gl-i18n/pro/campus/"
  },
  "common": {
    "environment": "pro",
    "services": {
      "0ef3a8c3-b219-4c10-905c-32f2c5feb4ef": "animixer",
      "1f41dd60-54ed-4eb1-9736-afea1cbd39eb": "resources",
      "23a1209f-8fa4-420c-ad01-d39515ae5c89": "kaepora",
      "50cb03f8-96d0-43a5-bf3a-9b119fb471e6": "admin",
      "5154560c-e86c-45a2-8ff5-bc38f11535d3": "editor",
      "623c139f-17de-4cea-a812-c96ab16d2ca0": "supervisor",
      "679ecd96-852c-49ce-a202-17aecb837eaf": "mars",
      "724876ad-4770-5359-aa18-799edafb6d1a": "lms",
      "7ef5ec6f-7f77-57d8-87c7-c7c47bf1a73e": "studentsPlatform",
      "813fa365-88fb-4de3-95e6-679b3a89290e": "services",
      "82c54e3e-60ac-43f1-a98a-3f39277ecf94": "reporting",
      "a03431b1-c799-4525-9400-bae0062e7afa": "arcade",
      "a0647baf-3ed5-484a-9240-4944dc7dbe5f": "accounts",
      "a5c180aa-3ca0-4869-b79e-c6612c7490b8": "campus",
      "d52c4f2e-c466-4304-aa71-1cd3c555716d": "studio",
      "dac71433-c04e-4a69-9bd9-047545960ce2": "kepler",
      "eff42bd7-b44d-4163-a51c-698bc0a804ef": "campusPwa"
    },
    "sids": {
      "accounts": "a0647baf-3ed5-484a-9240-4944dc7dbe5f",
      "admin": "50cb03f8-96d0-43a5-bf3a-9b119fb471e6",
      "animixer": "0ef3a8c3-b219-4c10-905c-32f2c5feb4ef",
      "arcade": "a03431b1-c799-4525-9400-bae0062e7afa",
      "campus": "a5c180aa-3ca0-4869-b79e-c6612c7490b8",
      "campusPwa": "eff42bd7-b44d-4163-a51c-698bc0a804ef",
      "editor": "5154560c-e86c-45a2-8ff5-bc38f11535d3",
      "kaepora": "23a1209f-8fa4-420c-ad01-d39515ae5c89",
      "kepler": "dac71433-c04e-4a69-9bd9-047545960ce2",
      "lms": "724876ad-4770-5359-aa18-799edafb6d1a",
      "mars": "679ecd96-852c-49ce-a202-17aecb837eaf",
      "reporting": "82c54e3e-60ac-43f1-a98a-3f39277ecf94",
      "resources": "1f41dd60-54ed-4eb1-9736-afea1cbd39eb",
      "services": "813fa365-88fb-4de3-95e6-679b3a89290e",
      "studentsPlatform": "7ef5ec6f-7f77-57d8-87c7-c7c47bf1a73e",
      "studio": "d52c4f2e-c466-4304-aa71-1cd3c555716d",
      "supervisor": "623c139f-17de-4cea-a812-c96ab16d2ca0"
    }
  },
  "game2100-frontend": {},
  "gat-engine-front": {
    "apiHost": "https://api.gamelearn.io/",
    "assetsHost": "https://min.objects.gamelearn.io/statics/gat/",
    "assetsMediaHost": "https://dszv2c8p7i9xo.cloudfront.net/",
    "backHost": "https://api.gamelearn.io/gat-engine",
    "cookieDomain": "domain=.gamelearn.io",
    "resources": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "servicesUrl": "https://services.gamelearn.io",
    "studentsPlatform": "https://campus.gamelearn.io",
    "translationsHost": "https://min.objects.gamelearn.io/gl-i18n/pro/gat-games/"
  },
  "kaepora-frontend": {
    "VITE_API_URL": "https://api.gamelearn.io",
    "VITE_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "VITE_RESOURCES_HOST": "https://min.objects.gamelearn.io/kaepora/",
    "VITE_REST_URL": "https://rest.kaepora.gamelearn.io",
    "VITE_SERVICES_URL": "https://services.gamelearn.io",
    "VITE_SERVICE_ID": "23a1209f-8fa4-420c-ad01-d39515ae5c89",
    "VITE_TRANSLATION_HOST": "https://min.objects.gamelearn.io/gl-i18n/pro/kaepora/",
    "VITE_WEBSOCKET_REPORT_URL": "wss://report.kaepora.gamelearn.io:443",
    "VITE_WEBSOCKET_URL": "wss://ws.kaepora.gamelearn.io:443",
    "microfrontends": {
      "GlCookies": {
        "active": true,
        "components": [
          "modal"
        ],
        "script": "https://script.gamelearn.io/glcookies/glcookies.js"
      },
      "GlRoleplay": {
        "active": true,
        "apiUrl": "https://api.gamelearn.io",
        "apiUrlRoleplay": "https://rest.kaepora.gamelearn.io",
        "authorization": true,
        "script": "https://script.gamelearn.io/glroleplay/glroleplay.js",
        "translationsUrl": "https://min.objects.gamelearn.io/gl-i18n/pro/kaepora"
      }
    },
    "production": true
  },
  "kepler-frontend": {
    "VITE_API_URL": "https://api.gamelearn.io",
    "VITE_ASSETS_URL": "https://min.objects.gamelearn.io/kepler/assets",
    "VITE_CAMPUS_URL": "https://campus.gamelearn.io",
    "VITE_CLIENT": "58dccfba26561500117caf53",
    "VITE_COOKIE_DOMAIN": "domain=.gamelearn.io",
    "VITE_JOURNAL_AGENT": "https://journal-agent.gamelearn.io/journal.js",
    "VITE_JOURNAL_URL": "https://api.gamelearn.io/kepler-journal",
    "VITE_MINIO_URL": "https://min.objects.gamelearn.io/",
    "VITE_NODE_ENV": "production",
    "VITE_RESOURCES_HOST": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "VITE_SERVICES_URL": "https://services.gamelearn.io",
    "VITE_SERVICE_ID": "dac71433-c04e-4a69-9bd9-047545960ce2",
    "VITE_SOCKETS_URL": "wss://kepler-knit.gamelearn.io:443",
    "VITE_STATICS_URL": "https://min.objects.gamelearn.io/statics",
    "VITE_STREAMING_HOST": "https://streaming.st2.gamelearn.io/",
    "VITE_TOS_CLIENT_IDS": "654904619c64ea8274fdb26c",
    "VITE_TRANSLATION_HOST": "https://min.objects.gamelearn.io/gl-i18n/pro/kepler/",
    "production": true
  },
  "learning-management-system": {
    "ACCOUNTS_URL": "https://accounts.gamelearn.io/",
    "API_URL": "https://api.gamelearn.io",
    "AUTHORING_URL": "https://editor.gamelearn.io",
    "CAMPUS_URL": "https://campus.gamelearn.io/",
    "CLIENT": "5981fca94d82290bcbe957fe",
    "DOMAIN": "gamelearn.io",
    "MARS_API_URL": "https://marsv2-api.gamelearn.io",
    "MARS_ID": "000000000000000000000000",
    "REPORTS_URL": "https://reporting.gamelearn.io",
    "RESOURCES_HOST": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "SERVICES_URL": "https://services.gamelearn.io",
    "SERVICE_ID": "50cb03f8-96d0-43a5-bf3a-9b119fb471e6",
    "STREAMING_HOST": "https://streaming.st2.gamelearn.io/clients/",
    "SUPERVISOR_URL": "https://supervisor.gamelearn.io",
    "TRANSLATIONS_URL": "https://min.objects.gamelearn.io/gl-i18n/pro/learning-management-system/",
    "contentful": {
      "active": true,
      "contentTypeIds": {
        "warningMessage": "mensajeDeWarning"
      },
      "warningMessageActive": true
    },
    "dictionaryUrl": "https://min.objects.gamelearn.io/gl-style-dictionary",
    "ft": {
      "enableLogin": false
    },
    "gtm": {
      "enabled": true
    },
    "helpHero": {
      "hide": "false",
      "id": "OViXGTEquoc"
    },
    "journal": {
      "agent": "https://journal-agent.gamelearn.io/journal.js",
      "url": "https://api.gamelearn.io/journal"
    },
    "keplerLanguages": [
      {
        "key": "en",
        "value": "languages.english"
      },
      {
        "key": "es",
        "value": "languages.spanish"
      },
      {
        "key": "fr",
        "value": "languages.french"
      }
    ],
    "microfrontends": {
      "GlCookies": {
        "active": true,
        "components": [
          "modal"
        ],
        "script": "https://script.gamelearn.io/glcookies/glcookies.js"
      },
      "GlReports": {
        "active": false,
        "apiUrl": "https://api.gamelearn.io",
        "authorization": true,
        "script": "https://script.gamelearn.io/glreports/glreports.js",
        "translationsUrl": "https://min.objects.gamelearn.io/gl-i18n/pro/learning-management-system"
      },
      "GlRoleplay": {
        "active": true,
        "apiUrl": "https://api.gamelearn.io",
        "apiUrlRoleplay": "https://rest.kaepora.gamelearn.io",
        "authorization": true,
        "script": "https://script.gamelearn.io/glroleplay/glroleplay.js",
        "translationsUrl": "https://min.objects.gamelearn.io/gl-i18n/pro/kaepora"
      }
    },
    "oldGames": [
      "Merchants",
      "2100",
      "Triskelion5",
      "Pacific",
      "Mars",
      "ADA-GDPR",
      "RGPD",
      "PacificAirlines"
    ],
    "oldGamesCanonicNames": [
      "merchants",
      "2100",
      "triskelion_2018",
      "triskelion",
      "pacific",
      "mars",
      "ada",
      "ada_gdpr",
      "rgpd",
      "pacific_airlines"
    ],
    "production": true,
    "release": false,
    "sentry": {
      "dsn": "https://2854cdce1851431fa594a7b4f4c1d32c@o436063.ingest.sentry.io/5624301",
      "show": true
    },
    "servicesPlatform": "https://services.gamelearn.io",
    "zendeskSupportUrl": "https://support.game-learn.com"
  },
  "mars-frontend": {},
  "merchants-frontend": {},
  "reporting-tool": {
    "API_BIGQUERY_URL": "/reporting_sql",
    "API_CORE_URL": "/core",
    "API_CRAWLER_URL": "https://api.gamelearn.io/crawler",
    "API_REPORTING_URL": "/reporting",
    "API_URL": "https://api.gamelearn.io",
    "SERVICE_ID": "82c54e3e-60ac-43f1-a98a-3f39277ecf94",
    "TRANSLATIONS_URL": "https://min.objects.gamelearn.io/gl-i18n/pro/learning-management-system/",
    "dictionaryUrl": "https://min.objects.gamelearn.io/gl-style-dictionary",
    "journal": {
      "agent": "https://journal-agent.gamelearn.io/journal.js",
      "url": "https://api.gamelearn.io/journal"
    },
    "sentry": {
      "dsn": "https://5851520423bf4656852072beddd2e1da@o436063.ingest.sentry.io/5624291",
      "show": true
    }
  },
  "resources-manager-front": {
    "API_URL": "https://api.gamelearn.io",
    "CLIENT": "5981fca94d82290bcbe957fe",
    "RESOURCES_URL": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "SCENE_COMPOSER_URL": "https://scene-composer.gamelearn.io",
    "SERVICES_UID": "1f41dd60-54ed-4eb1-9736-afea1cbd39eb",
    "SERVICES_URL": "https://services.gamelearn.io",
    "TRANSLATIONS_URL": "https://min.objects.gamelearn.io/gl-i18n/pro/authoring/"
  },
  "services-platform": {
    "API_URL": "https://api.gamelearn.io",
    "CAMPUS_SID": "a5c180aa-3ca0-4869-b79e-c6612c7490b8",
    "CAMPUS_URL": "https://campus.gamelearn.io",
    "DOMAIN": "gamelearn.io",
    "ENV": "pro",
    "RECAPTCHA_SITEKEY": "6LcZUmkUAAAAAGWPYaPDi5nMHDcPGC7LXpfHY-u5",
    "RESOURCES_HOST": "https://min.objects.gamelearn.io/cooked.gl-lms-storage/clients/",
    "TRANSLATIONS_URL": "https://min.objects.gamelearn.io/gl-i18n/pro/services-platform/",
    "contentful": {
      "accessToken": "ee5c130c30267ab908f08f5244773edc1fadfa3a02d456a8e68f6e5b4cbd53a6",
      "active": true,
      "space": "fbgigh3s9vtp"
    },
    "dictionaryUrl": "https://min.objects.gamelearn.io/gl-style-dictionary",
    "gtm": {
      "enabled": true
    },
    "microfrontends": {
      "GlCookies": {
        "active": true,
        "components": [
          "banner",
          "footer"
        ],
        "script": "https://script.gamelearn.io/glcookies/glcookies.js"
      }
    },
    "oldGamesCanonicNames": [
      "merchants",
      "2100",
      "triskelion_2018",
      "triskelion",
      "pacific",
      "mars",
      "ada",
      "ada_gdpr",
      "rgpd",
      "pacific_airlines"
    ],
    "production": true,
    "sentry": {
      "dsn": "https://3858152c7bb04307af4a34f94e910762@o436063.ingest.sentry.io/5624347",
      "show": true
    }
  },
  "students-platform": {
    "DOMAIN": "gamelearn.io",
    "apiUrl": "https://api.gamelearn.io",
    "contentful": {
      "accessToken": "ee5c130c30267ab908f08f5244773edc1fadfa3a02d456a8e68f6e5b4cbd53a6",
      "active": true,
      "contentTypeIds": {
        "mensajeDeWarning": "mensajeDeWarning"
      },
      "space": "fbgigh3s9vtp"
    },
    "production": true,
    "release": true,
    "servicesPlatform": "https://services.gamelearn.io",
    "translationsUrl": "https://min.objects.gamelearn.io/gl-i18n/pro/students-platform/",
    "zendeskSupportUrl": "https://support.game-learn.com"
  },
  "supervisor-portal": {
    "BuketS3Link": "https://min.objects.gamelearn.io/fundae/",
    "TRANSLATIONS_URL": "https://min.objects.gamelearn.io/gl-i18n/pro/learning-management-system/",
    "apiUrl": "https://api.gamelearn.io",
    "gtm": {
      "enabled": true
    },
    "production": true,
    "serviceId": "623c139f-17de-4cea-a812-c96ab16d2ca0"
  },
  "triskelion-frontend": {}
}
